var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_components_1 = require("styled-components");
var react_feather_1 = require("react-feather");
var TreeNode_styled_1 = require("./TreeNode_styled");
var iconSize = 12;
var TreeNode = /** @class */ (function (_super) {
    __extends(TreeNode, _super);
    function TreeNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var _a = _this.props, onClick = _a.onClick, node = _a.node;
            onClick(node);
        };
        return _this;
    }
    TreeNode.prototype.render = function () {
        var _a = this.props, node = _a.node, openedIds = _a.openedIds, depth = _a.depth, onClick = _a.onClick, getIcon = _a.getIcon, theme = _a.theme;
        var icon = node.icon;
        if (icon === undefined && getIcon !== undefined) {
            icon = getIcon(node);
        }
        if (icon === undefined && node.children !== undefined) {
            icon = (React.createElement(react_feather_1.Folder, { color: theme.colors.muted, size: iconSize, style: { flexShrink: 0 } }));
        }
        var isOpened = openedIds.includes(node.id);
        var iconCount = node.children !== undefined ? 2 : 1;
        return (React.createElement(React.Fragment, null,
            React.createElement(TreeNode_styled_1.Item, { isDir: !!(node.children && node.children.length > 0), isCurrent: node.isCurrent, depth: depth, onClick: this.handleClick },
                React.createElement(TreeNode_styled_1.Icons, { iconCount: iconCount },
                    node.children !== undefined && isOpened && (React.createElement(react_feather_1.ChevronDown, { size: iconSize, style: { flexShrink: 0 } })),
                    node.children !== undefined && !isOpened && (React.createElement(react_feather_1.ChevronRight, { size: iconSize, style: { flexShrink: 0 } })),
                    icon),
                React.createElement("span", { style: { overflow: 'hidden', textOverflow: 'ellipsis' } }, node.label),
                node.isCurrent === true && React.createElement(TreeNode_styled_1.CurrentIndicator, null)),
            node.children && node.children.length > 0 && isOpened && (React.createElement(React.Fragment, null, node.children.map(function (child) { return (React.createElement(ThemedTreeNode, { key: child.id, node: child, openedIds: openedIds, onClick: onClick, getIcon: getIcon, depth: depth + 1 })); })))));
    };
    TreeNode.defaultProps = {
        depth: 0,
    };
    return TreeNode;
}(React.Component));
var ThemedTreeNode = styled_components_1.withTheme(TreeNode);
exports.default = ThemedTreeNode;
